// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2f$Linear from "./V2f.res.js";

function containsPoint(param, point) {
  return V2f$Linear.length(V2f$Linear.minus(point, param.pos)) < param.radius;
}

function intersectCircle(param, param$1) {
  return V2f$Linear.length(V2f$Linear.minus(param.pos, param$1.pos)) < param.radius + param$1.radius;
}

export {
  containsPoint,
  intersectCircle,
}
/* V2f-Linear Not a pure module */
